import { render } from "./BaseDisabledRadioGroup.vue?vue&type=template&id=8b51c538"
import script from "./BaseDisabledRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseDisabledRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__